import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=403d551a"
import script from "./factory.vue?vue&type=script&lang=js"
export * from "./factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports